<template>
  <div>
    <!-- 标题及按钮 -->
    <mtd-row>
      <mtd-col :span="12" class="height-full">
        <div class="page-title-32">{{ $getText('wenshu_web_module_file_circulation_alarm_summary', '文件流转告警汇总') }}</div>
      </mtd-col>
      <mtd-col :span="12" class="margin-bottom-0 text-right">
        <mtd-button type="primary" @click="open_user_setting" style="margin-right: 0;">{{ $getText('wenshu_web_module_set_alarm_period', '设置告警周期') }}</mtd-button>
      </mtd-col>
    </mtd-row>
    <!-- 数据来源检索 -->
    <mtd-row style="margin-top: 12px">
      <mtd-form :model="query_params" :label-width="120">
        <mtd-col :span="8">
          <mtd-form-item :label="$getText('wenshu_web_data_source', '数据来源') + ':'">
            <mtd-select v-model="query_params.dataSource" style="width: 100%" :placeholder="$getText('wenshu_web_please_select', '请选择')" @change="list_user_file" clearable>
              <mtd-option :label="$getText('wenshu_web_xuecheng', '学城')" value="km"/>
              <mtd-option :label="$getText('wenshu_web_module_daxiang', '大象')" value="xm"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-col>
      </mtd-form>
    </mtd-row>
    <!-- 文件流转记录 -->
    <mtd-table :data="alarm_list" size="small" :empty-text="$getText('wenshu_web_no_data', '暂无数据')">
      <mtd-table-column prop="filename" :label="$getText('wenshu_web_document_name', '文档名称')" show-overflow-tooltip width="400">
        <template slot-scope="scope">
          <span v-if="scope.row.dataSource === 'xm'">{{ scope.row.filename }}</span>
          <span v-if="scope.row.dataSource === 'km'">
              <a :href="'https://km.sankuai.com/page/'+scope.row.filemd5" target="_blank">{{ scope.row.filename }}</a>
            </span>
        </template>
      </mtd-table-column>
      <mtd-table-column prop="secretLevel" :label="$getText('wenshu_web_module_security_level', '密级')"/>
      <mtd-table-column prop="viewUserCnt" :label="$getText('wenshu_web_data_source', '数据来源')">
        <template slot-scope="scope">
          <span v-if="scope.row.dataSource === 'xm'">{{ $getText('wenshu_web_module_daxiang', '大象') }}</span>
          <span v-if="scope.row.dataSource === 'km'">{{ $getText('wenshu_web_xuecheng', '学城') }}</span>
        </template>
      </mtd-table-column>
      <mtd-table-column prop="viewUserCnt" :label="$getText('wenshu_web_module_viewer_count', '查看人数')">
        <template slot-scope="scope">
          {{ scope.row.viewUserCnt }}{{ $getText('wenshu_web_person', '人') }}
        </template>
      </mtd-table-column>
      <mtd-table-column prop="transferUserCnt" :label="$getText('wenshu_web_forward_count', '转发人数')">
        <template slot-scope="scope">
          {{ scope.row.transferUserCnt }}{{ $getText('wenshu_web_person', '人') }}
        </template>
      </mtd-table-column>
      <mtd-table-column prop="downloadUserCnt" :label="$getText('wenshu_web_module_downloader_count', '下载人数')">
        <template slot-scope="scope">
          {{ scope.row.downloadUserCnt }}{{ $getText('wenshu_web_person', '人') }}
        </template>
      </mtd-table-column>
      <mtd-table-column prop="outputUserCnt" :label="$getText('wenshu_web_module_forwarder_count', '外发人数')">
        <template slot-scope="scope">
          {{ scope.row.outputUserCnt }}{{ $getText('wenshu_web_person', '人') }}
        </template>
      </mtd-table-column>
      <mtd-table-column :label="$getText('wenshu_web_operation', '操作')" width="120">
        <template slot-scope="scope">
          <mtd-button type="text" size="small" @click="show_detail(scope.row.id, scope.row.filename)"
                      style="color: #0a70f5;padding-left: 0">
            {{ $getText('wenshu_web_module_view_details', '查看详情') }}
          </mtd-button>
        </template>
      </mtd-table-column>
    </mtd-table>
    <div style="text-align: right;margin-top: 12px;">
      <mtd-pagination size="small" :total="query_params.tn"
                      :page-size="query_params.sn" :current-page.sync="query_params.cn" @change="change_page"/>
    </div>
    <!-- 消息通知设置弹窗 -->
    <mtd-modal :title="$getText('wenshu_web_module_alarm_period_setting', '告警周期设置')" width="600px" v-model="user_setting_visible" @close="close_user_setting">
      <mtd-form ref="user_setting_form" :model="user_setting">
        <mtd-tabs v-model="setting_active_tab">
          <mtd-tab-pane :label="$getText('wenshu_web_module_daxiang', '大象')" value="setting_xm">
            <mtd-form-item :label="$getText('wenshu_web_module_alarm_period', '告警周期')" :label-width="92">
              <mtd-select type="text" v-model="user_setting.xm_send_cycle" style="width: 100px;">
                <mtd-option value="WEEK" :label="$getText('wenshu_web_one_week', '一周')"/>
                <mtd-option value="TWO_WEEK" :label="$getText('wenshu_web_module_two_weeks', '两周')"/>
                <mtd-option value="MONTH" :label="$getText('wenshu_web_one_month', '一月')"/>
              </mtd-select>
            </mtd-form-item>
          </mtd-tab-pane>
          <mtd-tab-pane :label="$getText('wenshu_web_xuecheng', '学城')" value="setting_km">
            <mtd-form-item :label="$getText('wenshu_web_module_alarm_period', '告警周期')" :label-width="92">
              <mtd-select type="text" v-model="user_setting.km_send_cycle" style="width: 100px;">
                <mtd-option value="DAY" :label="$getText('wenshu_web_one_day', '一天')"/>
                <mtd-option value="WEEK" :label="$getText('wenshu_web_one_week', '一周')"/>
              </mtd-select>
            </mtd-form-item>
          </mtd-tab-pane>
        </mtd-tabs>
      </mtd-form>
      <div slot="footer" class="demo-modal-footer" style="padding-top: 12px;">
        <mtd-button @click="close_user_setting">{{ $getText('wenshu_web_cancel', '取消') }}</mtd-button>
        <mtd-button type="primary" @click="submit_user_setting">{{ $getText('wenshu_web_confirm', '确定') }}</mtd-button>
      </div>
    </mtd-modal>
  </div>
</template>

<script>

import {mapActions} from 'vuex'

export default {
  name: "alert_index",
  data() {
    return {
      alarm_list: [],
      // 分页数据
      query_params: {
        dataSource: null,
        queryDt: null,
        misId: '',
        cn: 1, // 当前页面
        sn: 10, // 每页大小
        tn: 0 // 总条数
      },
      // 用户消息设置
      open_directly_tab: null,
      user_setting_visible: false,
      setting_active_tab: 'setting_xm',
      old_user_setting: {
        xm_send_cycle: 'WEEK',
        km_send_cycle: 'DAY'
      },
      user_setting: {
        xm_send_cycle: 'WEEK',
        km_send_cycle: 'DAY'
      },
    }
  },
  computed: {},
  mounted: function () {
    let query_params = this.$route.query;
    if (query_params) {
      let {dataSource, dt, settingFunction} = query_params;
      if (dataSource === 'xm' || dataSource === 'km') {
        this.query_params.dataSource = dataSource;
      }
      if (dt && (/^\d{8}$/.test(dt))) {
        this.query_params.queryDt = dt;
      }
      if (settingFunction === 'setting_xm' || settingFunction === 'setting_km') {
        this.open_directly_tab = settingFunction;
      }
    }
    this.list_user_file();
    this.load_user_setting();
  },
  methods: {
    // API方法
    ...mapActions({
      api_list_file: 'api_file_trace_query_file',
      api_query_user_setting: 'api_file_trace_query_user_setting',
      api_submit_user_setting: 'api_file_trace_submit_user_setting',
    }),
    list_user_file() {
      this.query_params.limit = this.query_params.sn;
      this.query_params.page = this.query_params.cn;
      this.api_list_file(this.query_params).then((res) => {
        if (res.code === 0) {
          let {currentPage, limit, total, items} = res.data;
          this.alarm_list = items;
          this.query_params.cn = currentPage;
          this.query_params.sn = limit;
          this.query_params.tn = total;
        } else {
          this.$mtd.message.error(this.$getText('wenshu_web_failed_to_get_data', '获取数据失败'));
        }
      });
    },
    change_page(current, size) {
      this.query_params.cn = current;
      this.query_params.sn = size;
      this.list_user_file()
    },
    show_detail(id, filename) {
      this.$router.push({
        name: "file|trace|alert_detail",
        params: {file_id: id, filename, dataSource: this.query_params.dataSource, queryDt: this.query_params.queryDt}
      });
    },
    load_user_setting() {
      this.api_query_user_setting().then((res) => {
        let data = res.data;
        if (data) {
          let {xmSetting, kmString} = data;
          this.old_user_setting = {
            xm_send_cycle: xmSetting,
            km_send_cycle: kmString
          }
          this.user_setting = {
            xm_send_cycle: xmSetting,
            km_send_cycle: kmString
          }
          // 判断一下是否直接打开页面
          if (this.open_directly_tab && this.open_directly_tab !== '') {
            this.setting_active_tab = this.open_directly_tab;
            this.open_user_setting();
          }
          this.open_directly_tab = null;
        }
      })
    },
    open_user_setting() {
      this.user_setting_visible = true;
    },
    close_user_setting() {
      this.user_setting_visible = false;
      // 重新加载配置数据
      this.load_user_setting();
      this.setting_active_tab = 'setting_xm';
      this.open_directly_tab = null;
    },
    submit_user_setting() {
      let {xm_send_cycle, km_send_cycle} = this.user_setting;
      let form_data = {xmSetting: xm_send_cycle, kmSetting: km_send_cycle};
      this.api_submit_user_setting(form_data).then(() => {
        this.$mtd.message.success(this.$getText('wenshu_web_module_set_submit_success', '设置提交成功'));
        this.close_user_setting();
      });
    },
  }
}
</script>

<style scoped>

@import "../../../styles/public.css";
@import "../../../styles/reset_table.css";

</style>
